import { createAction, props } from "@ngrx/store";

export const streamInit = createAction("[AccountCamMic] CamMic Stream Init");
export const streamDestroy = createAction(
  "[AccountCamMic] CamMic Stream Destroy"
);
export const streamFailure = createAction(
  "[AccountCamMic] CamMic Stream Failure",
  props<{ error: Error }>()
);
